import script from "./IdentificatorsControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdentificatorsControl.vue?vue&type=script&setup=true&lang=ts"

import "./IdentificatorsControl.vue?vue&type=style&index=0&id=562a9164&lang=scss"

const __exports__ = script;

export default __exports__